import type React from 'react';
import { Button as ChakraButton, type ResponsiveValue, useColorModeValue } from '@chakra-ui/react';

interface ButtonProps {
  text: string;
  bgColor?: string;
  onClick?: VoidFunction;
  fontSize?: ResponsiveValue<string | number>;
  px?: ResponsiveValue<string | number>;
  py?: ResponsiveValue<string | number>;
  variant?: 'solid' | 'outline' | 'ghost' | 'link';
  hoverBgColor?: string;
  hoverTextColor?: string;
}

const Button: React.FC<ButtonProps> = ({
  text,
  bgColor: bgColorProp,
  onClick,
  fontSize,
  px,
  py,
  variant = 'solid',
  hoverBgColor: hoverBgColorProp,
  hoverTextColor: hoverTextColorProp,
}) => {
  const defaultBg = useColorModeValue('#27ADE4', '#19C8F5');
  const defaultHoverBg = useColorModeValue('gray.800', 'white');
  const defaultHoverText = useColorModeValue('white', 'gray.800');
  const bgColor = bgColorProp ?? defaultBg;
  const hoverBgColor = hoverBgColorProp ?? defaultHoverBg;
  const hoverTextColor = hoverTextColorProp ?? defaultHoverText;
  const isOutline = variant === 'outline';

  return (
    <ChakraButton
      variant={variant}
      onClick={onClick}
      bgColor={isOutline ? 'none' : bgColor}
      _hover={
        isOutline
          ? undefined
          : {
              bgColor: hoverBgColor,
              color: hoverTextColor,
            }
      }
      borderRadius='full'
      width='fit-content'
      color={!isOutline ? 'white' : undefined}
      fontSize={
        fontSize ?? {
          base: '16px',
          sm: '20px',
          md: '24px',
        }
      }
      px={
        px ?? {
          base: '14px',
          md: '22px',
        }
      }
      py={
        py ?? {
          base: '8px',
          md: '28px',
        }
      }
      zIndex={1}
    >
      {text}
    </ChakraButton>
  );
};

export default Button;
